import type { ExtendedStarterTrackPoint } from '@racemap/utilities/functions/timing';

export const getDeviation = ({
  lastPoint,
  threshold = 1000,
}: {
  lastPoint: ExtendedStarterTrackPoint;
  threshold?: number;
}): number | null =>
  lastPoint.distanceToShadowTrack > threshold ? lastPoint.distanceToShadowTrack : null;
